import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme=>({
    rootLista: {
        width: '100%',
        maxWidth: '100%',
    },

    rootListItem: {
        justifyContent: 'flex-end',
        padding: '0px',

    },
    rootListItemText:{
        width: '220px',
        color: 'black',
        flex: '0 auto',
        textAlign: 'end',
        '&>.MuiTypography-root':{
            fontWeight:'bold',
        },
    },
    colorIcon:{
        textAlign: 'center',
        display: 'initial',
    },
    colorChip:{
        color:'black',
        marginTop:'10px',
        height:'auto',
        '&>.MuiChip-label':{
            whiteSpace: 'break-spaces',
        }
    },
    centerTitle: {
        textAlign: 'center',
        // marginTop: '10px',
        marginBottom: '10px',
        backgroundColor:'gainsboro',
    },    
    marginBotton:{
        marginBottom: '10px'
    },
    cardButtons: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
    containerContent: {
        paddingTop: '40px',
    }
}))